// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quick-pick-game-info {
  display: flex;
  flex-direction: row;
  width: 568px;
  height: 75px;
  margin: 24px auto !important;
}
@media (max-width: 900px) {
  .quick-pick-game-info {
    width: 318px !important;
    height: 43px !important;
  }
}
.quick-pick-game-info__team {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 10px !important;
  font-weight: 700 !important;
  color: #002129 !important;
}
@media (max-width: 900px) {
  .quick-pick-game-info__team {
    margin-top: -10px !important;
  }
}
.quick-pick-game-info__logo-container {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 900px) {
  .quick-pick-game-info__logo-container {
    width: 48px !important;
    height: 48px !important;
  }
}
.quick-pick-game-info__logo {
  width: 48px;
  height: 48px;
  object-fit: contain;
}
.quick-pick-game-info__record {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #002129 !important;
  white-space: nowrap;
}
@media (max-width: 900px) {
  .quick-pick-game-info__record {
    font-size: 12px !important;
  }
}
.quick-pick-game-info__score-column {
  display: flex;
  flex-direction: column;
  width: 88px;
  align-items: center;
  justify-content: center;
  font-size: 10px !important;
  font-weight: 700 !important;
  color: #002129 !important;
}
@media (max-width: 900px) {
  .quick-pick-game-info__score-column {
    width: 66px !important;
  }
}
.quick-pick-game-info__away-score-column {
  margin-left: 24px !important;
}
@media (max-width: 900px) {
  .quick-pick-game-info__away-score-column {
    margin-left: 8px !important;
  }
}
.quick-pick-game-info__home-score-column {
  margin-right: 16px !important;
}
@media (max-width: 900px) {
  .quick-pick-game-info__home-score-column {
    margin-right: 8px !important;
  }
}
.quick-pick-game-info__team-name {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #002129 !important;
}
@media (max-width: 900px) {
  .quick-pick-game-info__team-name {
    font-size: 12px !important;
  }
}
.quick-pick-game-info__score {
  font-size: 32px !important;
  font-weight: 700 !important;
  color: #002129 !important;
}
@media (max-width: 900px) {
  .quick-pick-game-info__score {
    font-size: 24px !important;
  }
}
.quick-pick-game-info__game-details {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 140px;
  color: #002129 !important;
  margin-left: 54px !important;
  margin-right: 54px !important;
}
@media (max-width: 900px) {
  .quick-pick-game-info__game-details {
    width: 88px !important;
    margin-left: 8px !important;
    margin-right: 8px !important;
  }
}
.quick-pick-game-info__text-line {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #002129 !important;
  white-space: nowrap;
}
@media (max-width: 900px) {
  .quick-pick-game-info__text-line {
    font-size: 12px !important;
  }
}
.quick-pick-game-info__text-line--live {
  color: #CC293C !important;
}

.quick-pick-card-container {
  width: 85%;
  max-width: 450px;
  margin: 0 auto; /* Optional: centers the box horizontally */
  margin-top: 20px; /* Optional: adjust for spacing */
}

.quick-pick-card-top-border {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border: 1px solid #002129;
  background-color: #C0C0C0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  width: 100%;
  margin: 0 auto;
}

.quick-pick-card-top-border-left-text {
  font-weight: 700 !important;
  color: #002129;
  text-align: center;
  margin-left: 10px !important;
}

.quick-pick-card-top-border-right-text {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #002129;
  text-align: center;
  margin-right: 10px !important;
}

.quick-pick-card-top-border-text {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #002129;
  text-align: center;
  margin: 0 auto !important;
}

.quick-pick-card-top-border-rewards-text {
  font-size: 16px !important;
  font-weight: 700 !important;
}

.quick-pick-card-info {
  border-right: 1px solid #002129;
  border-left: 1px solid #002129;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
  width: 100%;
  margin: 0 auto;
}

.quick-pick-card-info-text {
  color: #002129;
  font-size: 16px !important;
  font-weight: 700 !important;
}

.quick-pick-card-condition-text {
  color: #002129;
  font-size: 12px !important;
  font-weight: 500 !important;
  margin-bottom: 20px !important;
}

.quick-pick-card-result-container {
  border-right: 1px solid #002129;
  border-left: 1px solid #002129;
  background-color: #fff;
  padding: 0 16px 16px;
}

.quick-pick-card-result-text {
  color: #002129;
  font-size: 16px !important;
  font-weight: 700 !important;
}

.quick-pick-card-bottom-border {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border: 1px solid #002129;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 5px; /* Space between Typography components */
  padding: 5px;
  margin: 0 auto;
}

.quick-pick-card-bottom-border-text {
  color: #002129;
  font-size: 16px !important;
  font-weight: 500 !important;
}

.quick-pick-card-two-choice-container {
  border-right: 1px solid #002129;
  border-left: 1px solid #002129;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  gap: 15px;
  margin: 0 auto;
  padding: 16px;
}

.quick-pick-card-two-choice-button {
  display: flex;
  flex-direction: column;
  width: 130px;
  height: 102px;
  padding: 25px 29px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 16px;
  border: 3px solid #002129;
  cursor: pointer;
}

.quick-pick-card-two-choice-button-text {
  color: #002129;
  text-align: center;
  font-family: "Inter", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700 !important;
  line-height: normal;
}

.quick-pick-card-multiple-choice-container {
  border-right: 1px solid #002129;
  border-left: 1px solid #002129;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  gap: 15px;
  margin: 0 auto;
  padding: 16px;
}

.quick-pick-card-multiple-choice-button {
  display: flex;
  flex-direction: column;
  width: 95%;
  height: 51px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 16px;
  border: 3px solid #002129;
  cursor: pointer;
  margin: 0 auto;
}

.quick-pick-card-multiple-choice-button-text {
  color: #002129;
  text-align: center;
  font-family: "Inter", sans-serif;
  font-size: 20px !important;
  font-style: normal;
  font-weight: 700 !important;
  line-height: normal;
}

.quick-pick-card-multiple-choice-answers-text {
  color: #002129;
  text-align: center;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 700 !important;
  line-height: normal;
}`, "",{"version":3,"sources":["webpack://./src/components/QuickPickGames/CardPieces/CardPieces.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,4BAAA;AACF;AACE;EAPF;IAQI,uBAAA;IACA,uBAAA;EAEF;AACF;AAAE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,0BAAA;EACA,2BAAA;EACA,yBAAA;AAEJ;AAAI;EARF;IASE,4BAAA;EAGF;AACF;AAAE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAEJ;AAAI;EAPF;IAQI,sBAAA;IACA,uBAAA;EAGJ;AACF;AAAE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAEJ;AACE;EACE,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,mBAAA;AACJ;AACI;EANF;IAOI,0BAAA;EAEJ;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,yBAAA;AACJ;AACI;EAVF;IAWI,sBAAA;EAEJ;AACF;AACE;EACE,4BAAA;AACJ;AACI;EAHF;IAII,2BAAA;EAEJ;AACF;AACE;EACE,6BAAA;AACJ;AACI;EAHF;IAII,4BAAA;EAEJ;AACF;AACE;EACE,0BAAA;EACA,2BAAA;EACA,yBAAA;AACJ;AACI;EALF;IAMI,0BAAA;EAEJ;AACF;AACE;EACE,0BAAA;EACA,2BAAA;EACA,yBAAA;AACJ;AACI;EALF;IAMI,0BAAA;EAEJ;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,yBAAA;EACA,4BAAA;EACA,6BAAA;AACJ;AACI;EAVF;IAWI,sBAAA;IACA,2BAAA;IACA,4BAAA;EAEJ;AACF;AACE;EACE,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,mBAAA;AACJ;AACI;EANF;IAOI,0BAAA;EAEJ;AACF;AAAI;EACE,yBAAA;AAEN;;AAMA;EACE,UAAA;EACA,gBAAA;EACA,cAAA,EAAA,2CAAA;EACA,gBAAA,EAAA,iCAAA;AAHF;;AAMA;EACE,2BAAA;EACA,4BAAA;EACA,yBAAA;EACA,yBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;AAHF;;AAMA;EACE,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,4BAAA;AAHF;;AAMA;EACE,0BAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;AAHF;;AAMA;EACE,0BAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;AAHF;;AAMA;EACE,0BAAA;EACA,2BAAA;AAHF;;AAMA;EACE,+BAAA;EACA,8BAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;AAHF;;AAMA;EACE,cAAA;EACA,0BAAA;EACA,2BAAA;AAHF;;AAMA;EACE,cAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;AAHF;;AAMA;EACE,+BAAA;EACA,8BAAA;EACA,sBAAA;EACA,oBAAA;AAHF;;AAKA;EACE,cAAA;EACA,0BAAA;EACA,2BAAA;AAFF;;AASA;EACE,8BAAA;EACA,+BAAA;EACA,yBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,QAAA,EAAA,wCAAA;EACA,YAAA;EACA,cAAA;AANF;;AASA;EACE,cAAA;EACA,0BAAA;EACA,2BAAA;AANF;;AAWA;EACE,+BAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;AARF;;AAWA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AARF;;AAWA;EACE,cAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;AARF;;AAYA;EACE,+BAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;AATF;;AAYA;EACE,aAAA;EACA,sBAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;AATF;;AAYA;EACE,cAAA;EACA,kBAAA;EACA,gCAAA;EACA,0BAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;AATF;;AAYA;EACE,cAAA;EACA,kBAAA;EACA,gCAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;AATF","sourcesContent":[".quick-pick-game-info {\n  display: flex;\n  flex-direction: row;\n  width: 568px;\n  height: 75px;\n  margin: 24px auto !important;\n\n  @media (max-width: 900px) {\n    width: 318px !important;\n    height: 43px !important;\n  }\n\n  &__team {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    font-size: 10px !important;\n    font-weight: 700 !important;\n    color: #002129 !important;\n\n    @media (max-width: 900px) {\n    margin-top: -10px !important;\n    }\n  }\n\n  &__logo-container {\n    width: 50px;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    @media (max-width: 900px) {\n      width: 48px !important;\n      height: 48px !important;\n    }\n  }\n\n  &__logo {\n    width: 48px;\n    height: 48px;\n    object-fit: contain;\n  }\n\n  &__record {\n    font-size: 16px !important;\n    font-weight: 700 !important;\n    color: #002129 !important;\n    white-space: nowrap;\n\n    @media (max-width: 900px) {\n      font-size: 12px !important;\n    }\n  }\n\n  &__score-column {\n    display: flex;\n    flex-direction: column;\n    width: 88px;\n    align-items: center;\n    justify-content: center;\n    font-size: 10px !important;\n    font-weight: 700 !important;\n    color: #002129 !important;\n\n    @media (max-width: 900px) {\n      width: 66px !important;\n    }\n  }\n\n  &__away-score-column {\n    margin-left: 24px !important;\n\n    @media (max-width: 900px) {\n      margin-left: 8px !important;\n    }\n  }\n\n  &__home-score-column {\n    margin-right: 16px !important;\n\n    @media (max-width: 900px) {\n      margin-right: 8px !important;\n    }\n  }\n\n  &__team-name {\n    font-size: 16px !important;\n    font-weight: 700 !important;\n    color: #002129 !important;\n\n    @media (max-width: 900px) {\n      font-size: 12px !important;\n    }\n  }\n\n  &__score {\n    font-size: 32px !important;\n    font-weight: 700 !important;\n    color: #002129 !important;\n\n    @media (max-width: 900px) {\n      font-size: 24px !important;\n    }\n  }\n\n  &__game-details {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 140px;\n    color: #002129 !important;\n    margin-left: 54px !important;\n    margin-right: 54px !important;\n\n    @media (max-width: 900px) {\n      width: 88px !important;\n      margin-left: 8px !important;\n      margin-right: 8px !important;\n    }\n  }\n\n  &__text-line {\n    font-size: 16px !important;\n    font-weight: 700 !important;\n    color: #002129 !important;\n    white-space: nowrap;\n\n    @media (max-width: 900px) {\n      font-size: 12px !important;\n    }\n\n    &--live {\n      color: #CC293C !important;\n    }\n  }\n}\n\n\n\n\n.quick-pick-card-container {\n  width: 85%;\n  max-width: 450px;\n  margin: 0 auto; /* Optional: centers the box horizontally */\n  margin-top: 20px; /* Optional: adjust for spacing */;\n}\n\n.quick-pick-card-top-border {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  border: 1px solid #002129;\n  background-color: #C0C0C0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px;  // Optional, adjust for spacing\n  width: 100%;\n  margin: 0 auto;\n}\n\n.quick-pick-card-top-border-left-text {\n  font-weight: 700 !important;\n  color: #002129;\n  text-align: center;\n  margin-left: 10px !important;\n}\n\n.quick-pick-card-top-border-right-text {\n  font-size: 16px !important;\n  font-weight: 700 !important;\n  color: #002129;\n  text-align: center;\n  margin-right: 10px !important;\n}\n\n.quick-pick-card-top-border-text {\n  font-size: 16px !important;\n  font-weight: 700 !important;\n  color: #002129;\n  text-align: center;\n  margin: 0 auto !important;\n}\n\n.quick-pick-card-top-border-rewards-text {\n  font-size: 16px !important;\n  font-weight: 700 !important;\n}\n\n.quick-pick-card-info {\n  border-right: 1px solid #002129;\n  border-left: 1px solid #002129;\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 10px;  // Optional, adjust for spacing\n  width: 100%;\n  margin: 0 auto;\n}\n\n.quick-pick-card-info-text {\n  color: #002129;\n  font-size: 16px !important;\n  font-weight: 700 !important;\n}\n\n.quick-pick-card-condition-text {\n  color:#002129;\n  font-size: 12px !important;\n  font-weight: 500 !important;\n  margin-bottom: 20px !important;\n}\n\n.quick-pick-card-result-container {\n  border-right: 1px solid #002129;\n  border-left: 1px solid #002129;\n  background-color: #fff;\n  padding: 0 16px 16px;\n}\n.quick-pick-card-result-text {\n  color: #002129;\n  font-size: 16px !important;\n  font-weight: 700 !important;\n}\n\n\n\n\n\n.quick-pick-card-bottom-border {\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  border: 1px solid #002129;\n  background-color: #fff;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  gap: 5px; /* Space between Typography components */\n  padding: 5px;\n  margin: 0 auto;\n}\n\n.quick-pick-card-bottom-border-text {\n  color: #002129;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n}\n\n\n\n.quick-pick-card-two-choice-container {\n  border-right: 1px solid #002129;\n  border-left: 1px solid #002129;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n  gap: 15px;\n  margin: 0 auto;\n  padding: 16px;\n}\n\n.quick-pick-card-two-choice-button {\n  display: flex;\n  flex-direction: column;\n  width: 130px;\n  height: 102px;\n  padding: 25px 29px;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  border-radius: 16px;\n  border: 3px solid #002129;\n  cursor: pointer;\n}\n\n.quick-pick-card-two-choice-button-text {\n  color: #002129;\n  text-align: center;\n  font-family: 'Inter', sans-serif;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700 !important;\n  line-height: normal;\n}\n\n\n.quick-pick-card-multiple-choice-container {\n  border-right: 1px solid #002129;\n  border-left: 1px solid #002129;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n  gap: 15px;\n  margin: 0 auto;\n  padding: 16px;\n}\n\n.quick-pick-card-multiple-choice-button {\n  display: flex;\n  flex-direction: column;\n  width: 95%;\n  height: 51px;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  border-radius: 16px;\n  border: 3px solid #002129;\n  cursor: pointer;\n  margin: 0 auto;\n}\n\n.quick-pick-card-multiple-choice-button-text {\n  color: #002129;\n  text-align: center;\n  font-family: 'Inter', sans-serif;\n  font-size: 20px !important;\n  font-style: normal;\n  font-weight: 700 !important;\n  line-height: normal;\n}\n\n.quick-pick-card-multiple-choice-answers-text {\n  color: #002129;\n  text-align: center;\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 700 !important;\n  line-height: normal;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
